import React, {useContext, useState} from 'react';
import HeaderActions from '../../../common/DasnboardHeader/HeaderActions';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import CatalogueLists from './CatalogueList';
import {useNavigate} from 'react-router-dom';
import {StateContext} from '../../../store';
import NewCatalogueList from './NewCatalogueList';
import DashboardHeader from '../../../common/DasnboardHeader/DashboardHeader';
import CategoryIcon from '@mui/icons-material/Category';
import {styleBg} from '../../../common/Models/Validations';
import PageWrapper from '../../../common/PageWrapper/PageWrapper';

function CustomTabPanel(props) {
  const {children, value, index, ...other} = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{pt: 3}}>
          {children}
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function CatalogueArtefacts() {
  const {role} = useContext(StateContext);
  const navigate = useNavigate();
  const [value, setValue] = React.useState(0);
  const [meta, setMeta] = useState({total: 0});
  const isAdminOrChief = role?.id === 1 || role?.id === 10;

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleOpen = () => {
    navigate('/management/catalogue-artefacts/create');
  }

  const handleDescription = () => {
    if(value === 0) {
      return "New Catalog Total"
    } else if (value === 1) {
      return "Approved Catalog Total"
    } else if (value === 2) {
      return "Rejected Catalog Total"
    } else {
      return "Resubmitted Catalog Total"
    }
  }

  return (
    <PageWrapper>
      {role?.id === 3 ? (
        <DashboardHeader title={'Catalog Artifacts'} total={meta?.total} IconName={CategoryIcon} iconColor={'#ff9653'} desc={handleDescription()} btnName={'+ Artifacts'} handleOpen={handleOpen}/>
      ) : (role?.id === 2 || isAdminOrChief) ? (
        <DashboardHeader title={'Catalog Artifacts'} total={meta?.total} IconName={CategoryIcon} iconColor={'#ff9653'} desc={handleDescription()}/>
      ) : (
        <DashboardHeader title={'Catalog Artifacts'} total={meta?.total} IconName={CategoryIcon} iconColor={'#ff9653'} desc={handleDescription()} btnName={'+ Artifacts'} handleOpen={handleOpen}/>
      )}
      <Box sx={{ borderBottom: 1, borderColor: 'divider', width: '100%', mt:2}}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" variant="scrollable" scrollButtons="auto">
          <Tab label="NEW TASK" {...a11yProps(0)} sx={{minWidth: 200, ...styleBg(0, value)}} />
          <Tab label="PAST TASK" {...a11yProps(1)} sx={{minWidth: 200, ...styleBg(1, value)}} />
          {/* <Tab label="REJECTED CATALOG" {...a11yProps(2)} sx={{minWidth: 200, ...styleBg(2, value)}} />
          <Tab label="RESUBMITTED CATALOG" {...a11yProps(3)} sx={{minWidth: 200, ...styleBg(3, value)}} />
          {(role?.id === 3 || role?.id === 5 || role?.id === 6) && (
            <Tab label="FORWARDED TO CURATOR" {...a11yProps(4)} sx={{minWidth: 200, ...styleBg(4, value)}} />
          )} */}
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        {(isAdminOrChief || role?.id === 2 || role?.id === 3) ?
          <NewCatalogueList role={role} meta={meta} setMeta={setMeta}/> :
          <CatalogueLists activeTask meta={meta} setMeta={setMeta} role={role}/>
        }
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <CatalogueLists meta={meta} setMeta={setMeta} role={role}/>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <CatalogueLists status={'rejected'} meta={meta} setMeta={setMeta} role={role}/>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <CatalogueLists status={'resubmitted'} meta={meta} setMeta={setMeta} role={role}/>
      </CustomTabPanel>
      {(role?.id === 3 || role?.id === 5 || role?.id === 6) &&
      <CustomTabPanel value={value} index={4}>
        <CatalogueLists status={'forwarded_to_curator'} meta={meta} setMeta={setMeta} role={role}/>
      </CustomTabPanel>}
    </PageWrapper>
  );
}